/* TGM Collection Carousel V2 — controller with effect variants, autoplay, dots */
(function () {
  'use strict';

  function readVar(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    return v || fallback;
  }

  function initCarousel(root) {
    if (root.__tgmInitialized) return;
    root.__tgmInitialized = true;

    var viewport = root.querySelector('[data-tgm-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tgm-card]'));
    var prevBtn = root.querySelector('[data-tgm-prev]');
    var nextBtn = root.querySelector('[data-tgm-next]');
    var dotsWrap = root.querySelector('[data-tgm-dots]');
    var counterEl = root.querySelector('[data-tgm-counter]');
    var counterCurrent = counterEl ? counterEl.querySelector('[data-tgm-current]') : null;
    var counterTotal = counterEl ? counterEl.querySelector('[data-tgm-total]') : null;
    var total = cards.length;
    if (!total) return;

    var settings = {
      effect: root.dataset.effect || 'coverflow',
      sideDesktop: parseInt(root.dataset.sideDesktop, 10) || 2,
      sideTablet: parseInt(root.dataset.sideTablet, 10) || 1,
      sideMobile: parseInt(root.dataset.sideMobile, 10) || 1,
      speed: parseInt(root.dataset.speed, 10) || 600,
      easing: root.dataset.easing || 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      autoplay: root.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(root.dataset.autoplaySpeed, 10) || 5000,
      pauseOnHover: root.dataset.pauseOnHover === 'true',
      loop: root.dataset.loop === 'true',
      wheel: root.dataset.wheel === 'true',
      keyboard: root.dataset.keyboard === 'true',
      swipe: root.dataset.swipe === 'true',
      showDots: root.dataset.showDots === 'true'
    };

    var ROT = parseFloat(readVar(root, '--tgm-rot', '35deg')) || 35;
    var SCALE = parseFloat(readVar(root, '--tgm-scale', '0.75')) || 0.75;
    var OPACITY = parseFloat(readVar(root, '--tgm-opacity', '0.7')) || 0.7;
    var BLUR = parseFloat(readVar(root, '--tgm-blur', '1px')) || 1;
    var GAP = parseFloat(readVar(root, '--tgm-gap', '70%')) || 70;

    var activeIndex = 0;
    var animating = false;
    var autoplayTimer = null;
    var hovered = false;

    function currentSide() {
      if (window.matchMedia('(max-width: 767px)').matches) return settings.sideMobile;
      if (window.matchMedia('(max-width: 1023px)').matches) return settings.sideTablet;
      return settings.sideDesktop;
    }

    function circularOffset(from, to, len) {
      if (!settings.loop) return to - from;
      var raw = to - from;
      if (raw > len / 2) raw -= len;
      if (raw < -len / 2) raw += len;
      return raw;
    }

    function styleFor(offset, side) {
      var abs = Math.abs(offset);
      var isActive = (offset === 0);
      var hidden = (abs > side);
      var base = {
        transition:
          'transform ' + settings.speed + 'ms ' + settings.easing +
          ', opacity ' + settings.speed + 'ms ease' +
          ', filter ' + settings.speed + 'ms ease',
        isActive: isActive,
        pointerEvents: hidden ? 'none' : 'auto',
        cursor: isActive ? 'default' : (hidden ? 'default' : 'pointer')
      };

      if (settings.effect === 'fade') {
        base.transform = 'translate(-50%, 0) scale(' + (isActive ? 1 : 0.94) + ')';
        base.opacity = isActive ? 1 : 0;
        base.filter = 'blur(0)';
        base.zIndex = isActive ? 30 : 1;
        return base;
      }

      if (settings.effect === 'flat') {
        var xf = offset * (GAP);
        base.transform = 'translate(calc(-50% + ' + xf + '%), 0) scale(' + (isActive ? 1 : SCALE) + ')';
        base.opacity = hidden ? 0 : (isActive ? 1 : OPACITY);
        base.filter = 'blur(0)';
        base.zIndex = 30 - abs;
        return base;
      }

      if (settings.effect === 'stack') {
        // active in center; others stacked behind with reduced scale + z, no rotation
        if (isActive) {
          base.transform = 'translate(-50%, 0) scale(1) translateZ(60px)';
          base.opacity = 1;
          base.filter = 'blur(0)';
          base.zIndex = 30;
        } else if (hidden) {
          base.transform = 'translate(-50%, 0) scale(0.5) translateZ(-800px)';
          base.opacity = 0;
          base.zIndex = 1;
        } else {
          var s = SCALE * (1 - (abs - 1) * 0.15);
          var yOff = abs * 12;
          base.transform = 'translate(-50%, ' + yOff + 'px) scale(' + s + ') translateZ(' + (-40 * abs) + 'px)';
          base.opacity = OPACITY * (1 - (abs - 1) * 0.3);
          base.filter = 'blur(' + (BLUR * abs * 0.6) + 'px)';
          base.zIndex = 30 - abs;
        }
        return base;
      }

      // coverflow (default)
      if (isActive) {
        base.transform = 'translate(-50%, 0) rotateY(0deg) scale(1) translateZ(60px)';
        base.opacity = 1;
        base.filter = 'blur(0)';
        base.zIndex = 30;
        return base;
      }
      if (hidden) {
        base.transform = 'translate(-50%, 0) rotateY(0deg) scale(0.35) translateZ(-800px)';
        base.opacity = 0;
        base.filter = 'blur(0)';
        base.zIndex = 1;
        return base;
      }
      var sign = offset < 0 ? 1 : -1;
      var xPct = offset < 0 ? -1 : 1;
      var slot = Math.min(abs, 4);
      var rotMult = slot === 1 ? 1 : slot === 2 ? 1.4 : slot === 3 ? 1.6 : 1.7;
      var scaleMult = slot === 1 ? 1 : slot === 2 ? 0.8 : slot === 3 ? 0.6 : 0.5;
      var tz = slot === 1 ? -40 : slot === 2 ? -140 : slot === 3 ? -260 : -380;
      var txBase = slot === 1 ? GAP : slot === 2 ? GAP * 1.92 : slot === 3 ? GAP * 2.7 : GAP * 3.4;
      var opMult = slot === 1 ? 1 : slot === 2 ? 0.65 : slot === 3 ? 0.35 : 0.2;
      var blurMult = slot === 1 ? 0.6 : slot === 2 ? 1 : slot === 3 ? 1.6 : 2.2;
      var zIdx = slot === 1 ? 20 : slot === 2 ? 10 : slot === 3 ? 5 : 2;

      base.transform =
        'translate(-50%, 0)' +
        ' rotateY(' + (ROT * rotMult * sign) + 'deg)' +
        ' scale(' + (SCALE * scaleMult) + ')' +
        ' translateX(' + (txBase * xPct) + '%)' +
        ' translateZ(' + tz + 'px)';
      base.opacity = OPACITY * opMult;
      base.filter = 'blur(' + (BLUR * blurMult).toFixed(2) + 'px)';
      base.zIndex = zIdx;
      return base;
    }

    function applyStyle(card, s) {
      card.style.transition = s.transition || '';
      card.style.transform = s.transform;
      card.style.opacity = s.opacity;
      card.style.zIndex = s.zIndex;
      card.style.filter = s.filter || '';
      card.style.pointerEvents = s.pointerEvents;
      card.style.cursor = s.cursor;
      if (s.isActive) card.classList.add('tgm-carousel__card--active');
      else card.classList.remove('tgm-carousel__card--active');
      card.setAttribute('aria-hidden', s.isActive ? 'false' : 'true');
    }

    function render() {
      var side = currentSide();
      cards.forEach(function (card, i) {
        var offset = circularOffset(activeIndex, i, total);
        applyStyle(card, styleFor(offset, side));
      });
      updateDots();
      updateCounter();
    }

    function goTo(index) {
      if (animating) return;
      if (settings.loop) {
        index = ((index % total) + total) % total;
      } else {
        if (index < 0 || index >= total) return;
      }
      if (index === activeIndex) return;
      animating = true;
      activeIndex = index;
      render();
      window.setTimeout(function () { animating = false; }, settings.speed);
    }

    function next() { goTo(activeIndex + 1); }
    function prev() { goTo(activeIndex - 1); }

    // Cards click
    cards.forEach(function (card, i) {
      card.addEventListener('click', function (e) {
        var isActive = card.classList.contains('tgm-carousel__card--active');
        if (isActive) {
          var target = e.target;
          if (target.closest('.tgm-carousel__card-button') || target.closest('.tgm-carousel__card-link')) return;
          var url = card.getAttribute('data-url');
          if (url) window.location.href = url;
          return;
        }
        e.preventDefault();
        goTo(i);
        restartAutoplay();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartAutoplay(); });

    // Dots
    if (settings.showDots && dotsWrap) {
      for (var d = 0; d < total; d++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tgm-carousel__dot';
        btn.setAttribute('aria-label', 'Go to slide ' + (d + 1));
        btn.dataset.tgmDot = d;
        (function (idx) {
          btn.addEventListener('click', function () { goTo(idx); restartAutoplay(); });
        })(d);
        dotsWrap.appendChild(btn);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.tgm-carousel__dot');
      dots.forEach(function (dot, i) {
        if (i === activeIndex) dot.classList.add('tgm-carousel__dot--active');
        else dot.classList.remove('tgm-carousel__dot--active');
      });
    }

    function updateCounter() {
      if (counterCurrent) counterCurrent.textContent = (activeIndex + 1);
      if (counterTotal) counterTotal.textContent = total;
    }

    // Keyboard
    if (settings.keyboard) {
      viewport.setAttribute('tabindex', '0');
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); restartAutoplay(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); next(); restartAutoplay(); }
        else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
        else if (e.key === 'End') { e.preventDefault(); goTo(total - 1); }
      });
    }

    // Swipe
    if (settings.swipe) {
      var tStartX = 0, tStartY = 0, tMoved = false, tThreshold = 40;
      viewport.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        tStartX = e.touches[0].clientX; tStartY = e.touches[0].clientY; tMoved = false;
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - tStartX;
        var dy = e.touches[0].clientY - tStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) tMoved = true;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (!tMoved) return;
        var dx = (e.changedTouches[0] || {}).clientX - tStartX;
        if (Math.abs(dx) > tThreshold) { if (dx < 0) next(); else prev(); restartAutoplay(); }
      }, { passive: true });
    }

    // Wheel
    if (settings.wheel) {
      var wheelLock = false;
      viewport.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) < 20 && Math.abs(e.deltaX) < 20) return;
        e.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        var d = e.deltaY + e.deltaX;
        if (d > 0) next(); else prev();
        restartAutoplay();
        setTimeout(function () { wheelLock = false; }, 550);
      }, { passive: false });
    }

    // Autoplay
    function startAutoplay() {
      if (!settings.autoplay) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(function () {
        if (!hovered) next();
      }, settings.autoplaySpeed);
    }
    function stopAutoplay() {
      if (autoplayTimer) { window.clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    function restartAutoplay() {
      if (!settings.autoplay) return;
      stopAutoplay(); startAutoplay();
    }
    if (settings.pauseOnHover) {
      root.addEventListener('mouseenter', function () { hovered = true; });
      root.addEventListener('mouseleave', function () { hovered = false; });
      root.addEventListener('focusin', function () { hovered = true; });
      root.addEventListener('focusout', function () { hovered = false; });
    }
    // Pause when out of viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    // Resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(render, 120);
    });

    render();
    startAutoplay();
  }

  function init() {
    document.querySelectorAll('[data-tgm-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-tgm-carousel]') : null;
    if (el) initCarousel(el);
  });
})();
